module.exports = __webpack_public_path__ + "static/media/LOGO-ELETRICOS.04756721.png";